<app-loader></app-loader>
<mat-card class="cardWithShadow">
  <mat-card-content class="p-24">
    <div class="row justify-content-between gap-16">
      <div class="col-sm-4">
        <span class="f-w-600 f-s-20  d-block align-items-center">{{ 'ENTITY.PATIENT' | translate }}</span>
        <!-- <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input matInput placeholder="Search Patient" [formControl]="globalsearchpatient" />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
          </mat-icon>
        </mat-form-field> -->
      </div>
      <div class="col-sm-4 d-flex align-items-center justify-content-end">
        <button mat-flat-button (click)="openDialog()" color="primary">
          <mat-icon>add</mat-icon>
          {{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.PATIENT' | translate }}
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="cardWithShadow m-0">
  <mat-card-content>
    <div class="table-responsive table-scroll-container-full">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 align-items-center">
            <div class="d-flex align-items-center gap-15">
              <span>{{ 'LABEL.NAME' | translate }}</span>
              <button mat-icon-button [matMenuTriggerFor]="patientNamemenu" aria-label="Filter Name">
                <mat-icon class="icon-16 d-flex align-items-center justify-content-center"
                  [ngClass]="{'text-primary': isFilterApplied()}">
                  filter_list
                </mat-icon>
              </button>
            </div>

            <mat-menu #patientNamemenu="matMenu" class="cardWithShadow" style="z-index:-1" yPosition="below"
              xPosition="before">
              <ng-template matMenuContent>
                <div class="p-x-16 p-y-8 w-250" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline" class="w-100 hide-hint">
                    <mat-label>{{ 'LABEL.FILTER' | translate }}</mat-label>
                    <mat-select [value]="selectedFilterName" (selectionChange)="onSerachChange($event,'Name')">
                      <mat-option *ngFor="let searchvalue of serachCompareList" [value]="searchvalue">
                        {{serachCompareOptionlable[searchvalue]}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="p-x-16 p-y-8 w-250" (click)="$event.stopPropagation()">
                  <form [formGroup]="searchForm">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-label>{{ 'LABEL.COLUMN_NAME' | translate }}</mat-label>
                      <mat-select [value]="selectedColumnName" (selectionChange)="onColumnChange($event)">
                        <mat-option *ngFor="let searchname of ListOfName" [value]="searchname">
                          {{searchname}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </form>
                </div>
                <div class="p-x-16 p-y-8 w-250">
                  <form [formGroup]="searchForm">
                    <mat-form-field *ngIf="selectedColumnName && searchForm.get(selectedColumnName)"
                      appearance="outline" class="w-100 hide-hint">
                      <mat-icon matPrefix>
                        <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
                      </mat-icon>
                      <input matInput
                        placeholder="{{ 'LABEL.SEARCH_LABEL' | translate }} {{ 'ENTITY.PATIENT' | translate }}"
                        [formControlName]="selectedColumnName" (click)="$event.stopPropagation()"
                        (input)="onSearchInputChanged()" />
                    </mat-form-field>
                  </form>

                </div>

              </ng-template>
            </mat-menu>

          </th>

          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center">
              <img class="rounded-circle"
                [src]="element.profileImagePath ? staticimagepath+ element.profileImagePath : 'assets/images/profile/user-1.jpg'"
                width="40" fallbackImage="assets/images/profile/user-1.jpg" />

              <div class="m-l-16">
                <p class="f-w-600 mat-subtitle-1 f-s-16 m-0">
                  {{element.salute}} {{element.firstName}}
                </p>
                <small class="mat-body-1 f-s-14">{{element.middleName}} {{element.lastName}}</small>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
            {{ 'LABEL.MOBILE_LABEL' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{ element.contactInfo?.[0]?.contact | defaultValue }}
          </td>
        </ng-container>

        <ng-container matColumnDef="patientno">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky sticky">
            {{ 'LABEL.PATIENT_NO' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{element.patientNumber}}
          </td>
        </ng-container>

        <ng-container matColumnDef="familyDR">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
            <div class="d-flex align-items-center gap-15">
              <span>{{ 'LABEL.FAMILY_DR' | translate }}</span>
              <button mat-icon-button [matMenuTriggerFor]="familyDRmenu" aria-label="Filter Name">
                <mat-icon class="icon-16 d-flex align-items-center justify-content-center"
                  [ngClass]="{'text-primary': searchForm.get('FamilyDr')?.value}">
                  filter_list
                </mat-icon>
              </button>
            </div>

            <mat-menu #familyDRmenu="matMenu" class="cardWithShadow" yPosition="below" xPosition="before">
              <ng-template matMenuContent>
                <div class="p-x-16 p-y-8 w-250" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline" class="w-100 hide-hint">
                    <mat-label>{{ 'LABEL.FILTER' | translate }}</mat-label>
                    <mat-select [value]="selectedFilterFamilyDr" (selectionChange)="onSerachChange($event,'FamilyDr')">
                      <mat-option *ngFor="let searchvalue of serachCompareList" [value]="searchvalue">
                        {{serachCompareOptionlable[searchvalue]}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="p-x-16 p-y-8 w-250" (click)="$event.stopPropagation()">
                  <form [formGroup]="searchForm">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-icon matPrefix>
                        <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
                      </mat-icon>
                      <input matInput placeholder="Search Family DR" formControlName="FamilyDr"
                        (click)="$event.stopPropagation()" />
                    </mat-form-field>
                  </form>
                </div>

              </ng-template>
            </mat-menu>

          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">{{ element.familyDr | defaultValue}}</td>
        </ng-container>

        <ng-container matColumnDef="Date of Birth">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
            {{ 'LABEL.DOB_LABEL' | translate }}
            <!-- <div class="d-flex align-items-center gap-15">
              <span>Date Of Birth</span>
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Filter Name">
                <mat-icon class="icon-16 d-flex align-items-center justify-content-center">
                  filter_list
                </mat-icon>
              </button>
            </div>

            <mat-menu #menu="matMenu" class="cardWithShadow">
              <ng-template matMenuContent>
                <div class="p-x-16 p-y-8 w-250">
                  <form [formGroup]="searchForm">
                    <div class="d-flex gap-16 align-items-center">
                      <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput [matDatepicker]="picker" formControlName="BirthDate" [min]="minDate"
                          [max]="maxDate" readonly (click)="picker.open()" (focus)="picker.open()">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>

                        <mat-datepicker #picker [color]="'primary'"></mat-datepicker>
                      </mat-form-field>
                      <button *ngIf="searchForm.get('BirthDate')?.value" mat-icon-button matSuffix
                        (click)="clearBirthDate($event)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </form>
                </div>

              </ng-template>
            </mat-menu> -->
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{ element.birthDate | date:"dd-MM-YYYY" }}
          </td>
        </ng-container>


        <ng-container matColumnDef="education">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
            <div class="d-flex align-items-center gap-15">
              <span>{{ 'LABEL.EDUCATION' | translate }}</span>
              <button mat-icon-button [matMenuTriggerFor]="educationmenu" aria-label="Filter Name">
                <mat-icon class="icon-16 d-flex align-items-center justify-content-center"
                  [ngClass]="{'text-primary': searchForm.get('Education')?.value}">
                  filter_list
                </mat-icon>
              </button>
            </div>

            <mat-menu #educationmenu="matMenu" class="cardWithShadow" yPosition="below" xPosition="before">
              <ng-template matMenuContent>
                <div class="p-x-16 p-y-8 w-250" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline" class="w-100 hide-hint">
                    <mat-label>{{ 'LABEL.FILTER' | translate }}</mat-label>
                    <mat-select [value]="selectedFilterEducation"
                      (selectionChange)="onSerachChange($event,'Education')">
                      <mat-option *ngFor="let searchvalue of serachCompareList" [value]="searchvalue">
                        {{serachCompareOptionlable[searchvalue]}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="p-x-16 p-y-8 w-250">
                  <form [formGroup]="searchForm">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                      <mat-icon matPrefix>
                        <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
                      </mat-icon>
                      <input matInput placeholder="search Education" formControlName="Education"
                        (click)="$event.stopPropagation()" />
                    </mat-form-field>
                  </form>
                </div>

              </ng-template>
            </mat-menu>

          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{element.education}}
          </td>
        </ng-container>

        <ng-container matColumnDef="maritalStatus">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
            <div class="d-flex align-items-center gap-15">
              <span>{{ 'LABEL.MARITAL_STATUS' | translate }}</span>
              <button mat-icon-button [matMenuTriggerFor]="maritalStatusmenu" aria-label="Filter Name">
                <mat-icon class="icon-16 d-flex align-items-center justify-content-center"
                  [ngClass]="{'text-primary': searchForm.get('MaritalStatus')?.value}">
                  filter_list
                </mat-icon>
              </button>
            </div>

            <mat-menu #maritalStatusmenu="matMenu" class="cardWithShadow" yPosition="below" xPosition="before">
              <ng-template matMenuContent>
                <div class="p-x-16 p-y-8 w-250" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline" class="w-100 hide-hint">
                    <mat-label>{{ 'LABEL.MARITAL_STATUS' | translate }}</mat-label>
                    <mat-select [value]="searchForm.get('MaritalStatus')?.value"
                      (selectionChange)="onMaritalStatusChange($event)">
                      <mat-option [value]="''">None</mat-option>
                      @for (marital of MaritalStatuslist; track marital) {
                      <mat-option [value]="marital.name">{{marital.name}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

              </ng-template>
            </mat-menu>
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{element.maritalStatus}}
          </td>
        </ng-container>

        <ng-container matColumnDef="age">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
            {{ 'LABEL.AGE' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{ element.birthDate | age }}
          </td>
        </ng-container>

        <ng-container matColumnDef="bloodGroup">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
            <div class="d-flex align-items-center gap-15">
              <span>{{ 'LABEL.BLOOD_GROUP' | translate }}</span>
              <button mat-icon-button [matMenuTriggerFor]="bloodGroupmenu" aria-label="Filter Name">
                <mat-icon class="icon-16 d-flex align-items-center justify-content-center"
                  [ngClass]="{'text-primary': searchForm.get('BloodGroup')?.value}">
                  filter_list
                </mat-icon>
              </button>
            </div>

            <mat-menu #bloodGroupmenu="matMenu" class="cardWithShadow" yPosition="below" xPosition="before">
              <ng-template matMenuContent>
                <div class="p-x-16 p-y-8 w-250" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline" class="w-100 hide-hint">
                    <mat-label>{{ 'LABEL.SEARCH_LABEL' | translate }} {{ 'LABEL.BLOOD_GROUP' | translate }}</mat-label>
                    <mat-select [value]="searchForm.get('BloodGroup')?.value"
                      (selectionChange)="onBloodGroupChange($event)">
                      <mat-option [value]="''">None</mat-option>
                      @for (blood of bloodgroupdetails; track blood) {
                      <mat-option [value]="blood">{{blood}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

              </ng-template>
            </mat-menu>
          </th>
          <td mat-cell *matCellDef="let element" class="f-s-14">
            {{element.bloodGroup | defaultValue}}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
            {{ 'LABEL.ACTION_LABEL' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="action-link">

            <a (click)="createOPD(element)" *ngIf="hasDoctors" class="m-r-10 cursor-pointer"
              matTooltip="Start Consultation">
              <i-tabler name="message" class="icon-20"></i-tabler>
            </a>

            <a (click)="viewPatientDetails(element)" class="m-r-10 cursor-pointer" matTooltip="View Patient Details">
              <i-tabler name="eye" class="icon-20"></i-tabler>
            </a>

            <a [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
              <i-tabler name="dots-vertical" class="icon-20"></i-tabler>
            </a>

            <mat-menu #menu="matMenu">
              <a class="p-y-3 text-decoration-none" (click)="editOpenDialog(element)">
                <div class="d-flex align-items-center inbox-list rounded p-12 cursor-pointer text-hover-primary">
                  <i-tabler name="edit" class="m-r-12 icon-20"></i-tabler>
                  <span class="f-w-400 f-s-14"> {{ 'LABEL.EDIT' | translate }}</span>
                </div>
              </a>
              <a class="p-y-3 text-decoration-none" (click)="deleteOpenDialog(element.id)">
                <div class="d-flex align-items-center inbox-list rounded p-12 cursor-pointer text-hover-primary">
                  <i-tabler name="trash" class="m-r-12 icon-20"></i-tabler>
                  <span class="f-w-400 f-s-14"> {{ 'BUTTON.BTN_DELETE' | translate }}</span>
                </div>
              </a>
              <a class="p-y-3 text-decoration-none" (click)="printLabel(element)">
                <div class="d-flex align-items-center inbox-list rounded p-12 cursor-pointer text-hover-primary">
                  <i-tabler name="printer" class="m-r-12 icon-20"></i-tabler>
                  <span class="f-w-400 f-s-14"> {{ 'LABEL.PRINT_LABEL' | translate }}</span>
                </div>
              </a>
            </mat-menu>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div *ngIf="dataSource.data.length===0">
        <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
      </div>
    </div>
  </mat-card-content>
  <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}" [length]="pagination.rowCount"
    [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true"
    [pageIndex]="pagination.currentPage">

  </mat-paginator>
</mat-card>